import {FC} from 'react';

import {ReportDelay} from '../../components/Reports/report/ReportDelay';

const DelayPage: FC = () => {
  return (
    <div>
      <ReportDelay />
    </div>
  );
};

export default DelayPage;
